import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { ContractOptionsEntity } from '../../../entities/mdqx/contract-options.entity';
import { ContractOptionsActions, ContractOptionsActionTypes } from '../../actions/mdqx/contract-options.actions';

export interface ContractOptionsState extends EntityState<ContractOptionsEntity> {
    fetched: boolean;
}

export const CONTRACT_OPTIONS_KEY = 'contractoptions';

const adapter = createEntityAdapter<ContractOptionsEntity>({
    selectId: contractOption => contractOption.Id,
});

const initialState: ContractOptionsState = adapter.getInitialState({
    fetched: false,
});

/* ############# */
/* ## REDUCER ## */
/* ############# */

export function contractOptionsReducer(state = initialState, action: ContractOptionsActions) {
    switch (action.type) {
        case ContractOptionsActionTypes.GetContractOptionsResponse: {
            return adapter.setAll(action.Payload, { ...state, fetched: true });
        }

        case ContractOptionsActionTypes.PostContractOptionsResponse: {
            return adapter.addOne(action.Payload, state);
        }

        case ContractOptionsActionTypes.PatchContractOptionsResponse: {
            return adapter.setOne(action.Payload, state);
        }

        case ContractOptionsActionTypes.DeleteContractOptionsResponse: {
            return adapter.removeOne(action.Payload, state);
        }

        default: {
            return state;
        }
    }
}

/* ############### */
/* ## SELECTORS ## */
/* ############### */

const { selectAll } = adapter.getSelectors();

export const selectAllContractOptions = selectAll;

export const selectContractOptionsFetched = (state: ContractOptionsState) => state.fetched;
